import { useNavigate, useLocation } from "react-router-dom";
import { Button } from "@/components/ui/button";
import Header from "@/components/Header";
import BottomBar from "@/components/BottomBar";
import { XCircle } from "lucide-react";

export default function KycFailed() {
  const navigate = useNavigate();
  const location = useLocation();
  const errorMessage = location.state?.message || "Verification failed. Please try again with clear document photos.";

  const handleRetry = () => {
    navigate("/kyc-onfido");
  };

  const handleGoHome = () => {
    navigate("/home");
  };

  return (
    <div className="min-h-screen bg-background">
      <Header showBack={false} />
      
      <div className="max-w-md mx-auto px-3 pb-20 flex flex-col min-h-[calc(100vh-120px)]">
        <div className="flex-1 flex flex-col items-center justify-center gap-8">
          <div className="w-24 h-24 bg-red-100 dark:bg-red-900/20 rounded-full flex items-center justify-center">
            <XCircle className="w-16 h-16 text-red-500" />
          </div>
          
          <div className="text-center">
            <h1 className="text-2xl font-bold mb-4">
              Verification Failed
            </h1>
            <p className="text-sm text-muted-foreground max-w-xs mx-auto">
              {errorMessage}
            </p>
          </div>
        </div>

        <div className="space-y-3">
          <Button
            onClick={handleRetry}
            className="w-full h-12 text-base font-semibold"
            size="lg"
          >
            Try Again
          </Button>
          
          <Button
            onClick={handleGoHome}
            variant="outline"
            className="w-full h-12 text-base font-semibold"
            size="lg"
          >
            Back to Home
          </Button>
        </div>

        {/* Progress Indicator - Error State */}
        <div className="flex gap-1 justify-center mt-8">
          <div className="w-20 h-2 bg-destructive rounded-sm" />
          <div className="w-20 h-2 bg-destructive rounded-sm" />
          <div className="w-20 h-2 bg-destructive rounded-sm" />
          <div className="w-20 h-2 bg-destructive rounded-sm" />
        </div>
      </div>

      <BottomBar />
    </div>
  );
}